export const STYLE_HEADER_TOOLBAR = 64
export const STYLE_SUBHEADER_TOOLBAR = 40
